import React from "react";
import { PwaContext, usePwaState } from "../hooks/usePWA";

/**
 * Supplies PWA state to the tree. Wrap the app once (see src/index.js).
 * Consume with `usePWA()` from `src/hooks/usePWA.js`.
 */
export function PwaProvider({ children }) {
  const value = usePwaState();
  return <PwaContext.Provider value={value}>{children}</PwaContext.Provider>;
}

export { usePWA, usePwa } from "../hooks/usePWA";
